<template>
<div v-if="initialized">
  <v-tabs v-model="tab" light icons-and-text>

    <v-tab href="#exposeInquiry">
      Anfragen
      <v-icon>$inquiry</v-icon>
    </v-tab>

    <v-tab href="#savedSearch">
      Suchprofile
      <v-icon>$search</v-icon>
    </v-tab>

    <v-tab href="#account">
      Mein Konto
      <v-icon>$user</v-icon>
    </v-tab>

    <v-spacer></v-spacer>

    <v-tab v-if="loading">
      <v-progress-circular
        :width="3"
        color="primary"
        indeterminate
      ></v-progress-circular>
    </v-tab>

    <v-tab @click="logout">
      {{ $t("Abmelden ")}}
      <v-icon>$logout</v-icon>
    </v-tab>
  </v-tabs>

  <v-tabs-items v-model="tab" class="mt-6">
    <v-tab-item value="exposeInquiry" v-if="tab == 'exposeInquiry'">
      <expose-inquiry-list></expose-inquiry-list>
    </v-tab-item>

    <v-tab-item value="savedSearch" v-if="tab == 'savedSearch'">
      <saved-search-list></saved-search-list>
    </v-tab-item>

    <v-tab-item value="account" v-if="tab == 'account'">
      <account></account>
    </v-tab-item>
  </v-tabs-items>

</div>
</template>

<script>
import SavedSearchList from './saved-search/SavedSearchList';
import ExposeInquiryList from "./ExposeInquiryList";
import Account from "./Account";

export default {
  name: "Home",

  components: {
    SavedSearchList,
    ExposeInquiryList,
    Account
  },

  props: [
    "k"
  ],

  data() {
    return {
      tab: "savedSearch",
      dialog: true,
      initialized: false
    }
  },

  computed: {
    contact() {
      return this.$store.state.contact.contact;
    },

    loading() {
      return this.$store.state.loading;
    }
  },

  created() {
    this.$emit("globalLoading", true);
    if (this.k) {
      this.$store.dispatch("ajax", {
        url: "/v1/wizard/confirm",
        method: "post",
        data: {
          k: this.k
        }
      }).then((res) => {
        if (!res) {
          return;
        }

        if ("opcode" in res && res.opcode == "Contact") {
          this.$store.dispatch("userMessage", {
            type: "success",
            msg: "Vielen Dank für Ihre Anfrage!"
          });
        }
      }).finally(() => {
        this.init();
      });
    } else {
      this.init();
    }
  },

  methods: {
    init() {
      this.$store.dispatch("contact/load").then(() => {
        this.initialized = true;
        this.$emit("globalLoading", false);
        if (!this.$store.getters["contact/disclaimerAccepted"]) {
          this.$store.commit("userDialog", { component: Account });
        }
      });
    },

    logout() {
      this.$store.dispatch("auth/logout");
    }
  }
};
</script>


